/**
 * AB 测试配置
 */
import env from '../utils/env';

/**
 * ab appid
 */
export const AbAppIds = {
  dev: '582253779819171903',
  qa: '582253779819171903',
  prod: '577869490457436221',
};

// ab试验应用Id
export const AbAppId = AbAppIds[env.appEnv];

/**
 * 订单页面试验Id
 */
export const OrderPageExpIds = {
  dev: '587661570973110322',
  qa: '587661570973110322',
  prod: '577870325237178432',
};

export const OrderPageReBuyBtnExpId = OrderPageExpIds[env.appEnv];

/**
 * 商品搜索页面试验Id
 */
export const SearchPageExpIds = {
  dev: '587662893978226764',
  qa: '587662893978226764',
  prod: '577870126464917568',
};

export const SearchPageExpId = SearchPageExpIds[env.appEnv];

/**
 * 商城首页试验 ID
 */
export const HomePageExpIds = {
  dev: '587663524038184986',
  qa: '587663524038184986',
  prod: '577869936718786617',
};

/**
 * 复购场景中患者可选开药门诊试验Id（复购二期）
 */
export const rePurchaseExpIds = {
  dev: '582256426513076285',
  qa: '582256426513076285',
  prod: '582261822355144745',
};

/** 对照组 */
export enum RePurchaseGroup {
  /** 空白对照组 60% */
  contrastEmpty = '0',
  /** 对照组A 20% */
  contrastA = '1',
  /** 对照组B 20% */
  contrastB = '2',
}

// abTest试验Id（复购二期）
export const rePurchaseExpId = rePurchaseExpIds[env.appEnv];

export const rePurchaseOrderExpABTestId = {
  dev: '610166364371419192',
  qa: '610166364371419192',
  prod: '610165299190169695',
};

export const rePurchaseOrderExpId = rePurchaseOrderExpABTestId[env.appEnv];

/**
 * 复购三期场景中试验Id
 */
export const rePurchaseExpThreeIds = {
  dev: '586970817972146216',
  qa: '586970817972146216',
  prod: '587335724827709507',
};

export enum RePurchaseThreeGroup {
  /** 空白对照组 50% */
  contrastEmpty = '0',
  /** 对照组 50% */
  contrast = '1',
}

// abTest试验三期Id
export const rePurchaseExpThreeId = rePurchaseExpThreeIds[env.appEnv];

/**
 * ab测试用户类型
 */
export enum AbUserTypeEnum {
  // 医生
  Doctor = 1,
  // 患者
  Patient = 2,
  // 经纪人
  Agent = 3,
}

/**
 * 砍医生补贴APPID
 * 已经完成：https://www.tapd.cn/20096901/prong/stories/view/1120096901001048958
 */
// export const cutDoctorSubsidiesIds = {
//   dev: '843186160791470162',
//   qa: '843186160791470162',
//   prod: '843578582222536783',
// };

// export const cutDoctorSubsidiesId = cutDoctorSubsidiesIds[env.appEnv];
